export default __webpack_public_path__ + "static/icon-11-6-520beeb3e987728ec643f9ae42e2a668.png";